import React from 'react';
import Icon from '@pushpay/icon';

const TickIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.48 5.266c-.566-.447-1.362-.317-1.78.29l-7.553 9.468-4.057-3.48c-.54-.483-1.343-.405-1.794.172-.45.579-.378 1.438.16 1.922a.737.737 0 00.044.037l5.091 4.365c.226.193.508.296.796.293.402.001.782-.2 1.024-.545L19.75 7.177c.418-.605.3-1.458-.265-1.906l-.005-.005z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default TickIcon;